<div class="guest-edit-container">
  <div class="column">
    @if (guestInfoConfig.length > 1) {
      <div class="guest-edit-row">
        <div class="activity-booking__location col-lg-5">
          <dynamic-form [config]="guestInfoConfig" #form="dynamicForm">
          </dynamic-form>
        </div>
      </div>
    }
  </div>


  @if (showIframe) {
    <div class="guest-details__iframe-view"><iframe width="560px" height="700px" frameBorder="0"
    [src]="urlSafe"></iframe></div>
  }

  <div class="row button-container">
    <app-button class="guest-edit-row" [buttontype]="cancelBtn" (valueChange)="clearDetails($event)"></app-button>
    <app-button class="guest-edit-row" [buttontype]="modifyBtn" (valueChange)="submitDetails($event)"></app-button>
  </div>
</div>